/**
 * From-file hub: ATS report, new CV with AI rewrite, or keep-look rewrite.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { trackChoiceAnalyze, trackChoiceKeepLook, trackChoiceRebuild } from '../utils/analytics';
import { KEEP_LOOK, KEEP_LOOK_ENABLED } from '../utils/paths';
import Seo from '../components/Seo';
import './FromFile.css';

const FromFile = () => {
  const { t } = useLanguage();

  return (
    <div className="container from-file">
      <Seo
        title={t('dashboard.fromFileTitle')}
        description={t('dashboard.fromFileLead')}
        path="/dashboard/from-file"
        noindex
      />
      <Link to="/dashboard" className="from-file__back">
        ← {t('dashboard.back')}
      </Link>

      <header className="from-file__header">
        <p className="from-file__step">{t('dashboard.stage2')}</p>
        <h1 className="from-file__title">{t('dashboard.fromFileTitle')}</h1>
        <p className="from-file__lead">{t('dashboard.fromFileLead')}</p>
      </header>

      <div className={`from-file__choices${KEEP_LOOK_ENABLED ? '' : ' is-two'}`}>
        <Link
          to="/dashboard/upload"
          className="from-choice from-choice--primary"
          onClick={() => trackChoiceAnalyze()}
        >
          <p className="from-choice__label">{t('dashboard.analyzeLabel')}</p>
          <h2 className="from-choice__title">{t('dashboard.analyzeTitle')}</h2>
          <p className="from-choice__desc">{t('dashboard.analyzeDesc')}</p>
          <p className="from-choice__result">{t('dashboard.analyzeResult')}</p>
          <span className="from-choice__cta">
            {t('dashboard.analyzeCta')} <span aria-hidden="true">→</span>
          </span>
        </Link>

        <Link
          to="/dashboard/quick-edit"
          className="from-choice from-choice--secondary"
          onClick={() => trackChoiceRebuild()}
        >
          <p className="from-choice__label">{t('dashboard.rebuildLabel')}</p>
          <h2 className="from-choice__title">{t('dashboard.rebuildTitle')}</h2>
          <p className="from-choice__desc">{t('dashboard.rebuildDesc')}</p>
          <p className="from-choice__result">{t('dashboard.rebuildResult')}</p>
          <span className="from-choice__cta">
            {t('dashboard.rebuildCta')} <span aria-hidden="true">→</span>
          </span>
        </Link>

        {KEEP_LOOK_ENABLED ? (
          <Link
            to={KEEP_LOOK}
            className="from-choice from-choice--keep"
            onClick={() => trackChoiceKeepLook()}
          >
            <p className="from-choice__label">{t('dashboard.keepLookLabel')}</p>
            <h2 className="from-choice__title">{t('dashboard.keepLookTitle')}</h2>
            <p className="from-choice__desc">{t('dashboard.keepLookDesc')}</p>
            <p className="from-choice__result">{t('dashboard.keepLookResult')}</p>
            <span className="from-choice__cta">
              {t('dashboard.keepLookCta')} <span aria-hidden="true">→</span>
            </span>
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default FromFile;
